<template>
	<v-list
		:dense="dense"
		:min-width="minWidth"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<slot></slot>
	</v-list>
</template>

<script>
export default {
	props: {
		dense: {
			type: Boolean,
			default: false
		},
		minWidth: {
			type: [Number, String],
			default: undefined
		}
	}
};
</script>